import RichTextInput from '../../../govwell-ui/components/RichTextInput/RichTextInput'
import { TanstackField } from '../../../utils/forms'

type Props<TKey extends string> = {
  caption?: React.ReactNode
  field: TanstackField<string, TKey>
  label?: React.ReactNode
  width?: React.CSSProperties['width']
  isRequired?: boolean
}
const RichTextInputField = <TKey extends string>({
  caption,
  field,
  label,
  width = '100%',
  isRequired,
}: Props<TKey>) => {
  return (
    <RichTextInput
      caption={caption}
      label={label}
      onValueChange={field.setValue}
      value={field.state.value}
      width={width}
      isRequired={isRequired}
    />
  )
}

export default RichTextInputField
